import React from 'react'
import Image from 'next/image'

import { Row, Rows, Column } from '@/components/layout'
import arrowsIconImg from '@/assets/buy-flow/right-side/arrows-icon.png'
import householdFinances from '@/assets/buy-flow/right-side/household-finances.png'
import scanRecords from '@/assets/buy-flow/right-side/scan-records.png'
import spendSmart from '@/assets/buy-flow/right-side/spend-smart.png'
import securedData from '@/assets/buy-flow/right-side/secured-data.png'

import styles from './CheckoutSideEmailNeatHome.module.scss'

export default function CheckoutSideEmail() {
  return (
    <Column center className={styles.background} gap={32} size={66}>
      <Rows className={styles.checkoutEmailContainer}>
        <Row>
          <Rows className={styles.left} gap={32}>
            <Row className={styles.headerContainer} gap={12}>
              <Image alt="" className={styles.neatLogo} src={arrowsIconImg} />
              <h1>NeatHome Smart<br /> Organization Software</h1>
            </Row>
          </Rows>
        </Row>
        <Row>
          <Rows className={styles.statsRows} gap={32}>
            <Row className={styles.stats}>
              <Image alt="" src={householdFinances} />
              <p>Ditch your spreadsheets and get all your household finances in one place</p>
            </Row>

            <Row className={styles.stats}>
              <Image alt="" src={scanRecords} />
              <p>Scan, extract, relax: turn your paper pile into perfect records</p>
            </Row>

            <Row className={styles.stats}>
              <Image alt="" src={spendSmart} />
              <p>Spend smart: track expenses, budget household, conquer!</p>
            </Row>

            <Row className={styles.stats}>
              <Image alt="" src={securedData} />
              <p>Your data. Secured like a vault</p>
            </Row>
          </Rows>
        </Row>
      </Rows>
    </Column>
  )
}
